import { motion } from "framer-motion";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";

const faqs = [
  {
    q: "Wo kann man in der Region Regensburg, Neumarkt oder Nürnberg Bowling spielen?",
    a: "Eine beliebte Adresse zum Bowling in der Oberpfalz ist Pirate Bowling Center in Velburg. Die Bowlinganlage liegt zentral zwischen Regensburg, Neumarkt und Nürnberg und ist daher aus der gesamten Region schnell erreichbar. Besucher erwartet eine moderne Bowlinganlage mit zusätzlichem Freizeitangebot wie Billard, Dart, Kicker und einer Cocktailbar, wodurch Pirate Bowling Center zu einem vielseitigen Ausflugsziel für Freunde, Familien und Gruppen wird.",
  },
  {
    q: "Warum ist Pirate Bowling Center Velburg eine gute Wahl zum Bowling in der Region?",
    a: "Pirate Bowling Center Velburg bietet mehr als nur Bowling. Die Anlage kombiniert Bowlingbahnen, Freizeitspiele und Gastronomie in einem besonderen Piraten-Ambiente. Gäste können neben Bowling auch Billard, Dart oder Kicker spielen und in der Bar Getränke oder Snacks genießen, was den Besuch zu einem kompletten Freizeiterlebnis macht.",
  },
  {
    q: "Ist Pirate Bowling Center Velburg auch für Familien und Kinder geeignet?",
    a: "Ja. Pirate Bowling Center Velburg ist sehr familienfreundlich und bietet Bowling-Spaß für jedes Alter. Einige Bahnen sind mit automatischen Seitenbegrenzungen (Bumpern) ausgestattet, sodass auch Kinder problemlos spielen können. Deshalb ist das Bowlingcenter besonders beliebt für Familienausflüge, Kindergeburtstage oder gemeinsame Freizeitaktivitäten.",
  },
  {
    q: "Kann man im Pirate Bowling Center Velburg einen Kindergeburtstag feiern?",
    a: "Ja. Pirate Bowling Center ist eine beliebte Location für Kindergeburtstage und Gruppenfeiern. Die Kombination aus Bowling, Spielmöglichkeiten und Gastronomie sorgt dafür, dass Kinder und Jugendliche gemeinsam einen aktiven und unterhaltsamen Geburtstag feiern können. Viele Familien aus der Region wählen Pirate Bowling Center Velburg genau aus diesem Grund als Geburtstagslocation.",
  },
  {
    q: "Gibt es im Pirate Bowling Center Velburg auch Essen und Getränke?",
    a: "Ja. Neben Bowling bietet Pirate Bowling Center Velburg einen Bistro- und Barbereich, in dem Snacks, kleine Gerichte und Getränke angeboten werden. In der Cocktailbar können Besucher außerdem verschiedene Cocktails genießen. Dadurch eignet sich das Bowlingcenter auch gut für einen längeren Abend mit Freunden oder Kollegen.",
  },
  {
    q: "Ist Pirate Bowling Center Velburg auch für Gruppen oder Firmenfeiern geeignet?",
    a: "Ja. Pirate Bowling Center Velburg eignet sich sehr gut für Gruppen, Vereinsausflüge oder Firmenfeiern. Für größere Gruppen können auf Anfrage sogar individuelle Angebote oder besondere Öffnungszeiten organisiert werden. Dadurch ist das Bowlingcenter eine beliebte Eventlocation für Teambuilding, Geburtstage oder gemeinsame Freizeitaktivitäten.",
  },
];

export default function FAQ() {
  return (
    <section
      id="faq"
      className="relative py-28 md:py-36 px-6 md:px-12 lg:px-20 section-alt"
      data-testid="faq-section"
    >
      <div className="max-w-3xl mx-auto relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <div className="skull-divider mb-6">
            <span className="font-space-grotesk text-xs text-gold tracking-[0.3em] uppercase px-3">FAQ</span>
          </div>
          <h2 className="font-unbounded text-4xl sm:text-5xl lg:text-6xl font-black text-cream leading-tight">
            Häufige{" "}
            <span className="gold-gradient-text">Fragen</span>
          </h2>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.15 }}
        >
          <Accordion type="single" collapsible className="space-y-3">
            {faqs.map((faq, i) => (
              <AccordionItem
                key={i}
                value={`faq-${i}`}
                className="glass border border-white/5 rounded-xl px-6 overflow-hidden"
                data-testid={`faq-item-${i}`}
              >
                <AccordionTrigger className="font-space-grotesk text-sm text-cream hover:text-gold py-5 text-left">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="font-inter text-sm text-cream/80 leading-relaxed pb-5">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
}
